import { render, staticRenderFns } from "./SaleOrderForm.vue?vue&type=template&id=8f768c24&scoped=true"
import script from "./SaleOrderForm.vue?vue&type=script&lang=js"
export * from "./SaleOrderForm.vue?vue&type=script&lang=js"
import style0 from "./SaleOrderForm.vue?vue&type=style&index=0&id=8f768c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f768c24",
  null
  
)

export default component.exports